// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useOrderHistoryDebouncedUpdateDraftParameter,
    useOrderHistoryState,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface OrderHistoryFilterFieldItemNumberProps {}

export interface OrderHistoryFilterFieldItemNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const OrderHistoryFilterFieldItemNumberStyles: OrderHistoryFilterFieldItemNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = OrderHistoryFilterFieldItemNumberStyles;

const OrderHistoryFilterFieldItemNumber: FC<OrderHistoryFilterFieldItemNumberProps> = () => {
    const { itemNumber } = useOrderHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useOrderHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(itemNumber);
    const id = useMemo(uniqueId, []);
    const label = translate("Item #");
    useEffect(() => {
        if (value !== itemNumber) {
            setValue(itemNumber);
        }
    }, [itemNumber]);

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ itemNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldItemNumber;
